import { render } from "./requestInfo.vue?vue&type=template&id=c64efb24&scoped=true"
import script from "./requestInfo.vue?vue&type=script&lang=js"
export * from "./requestInfo.vue?vue&type=script&lang=js"

import "./requestInfo.vue?vue&type=style&index=0&id=c64efb24&lang=scss&scoped=true"
import "./requestInfo.vue?vue&type=style&index=1&id=c64efb24&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64efb24"]])

export default __exports__